'use client';

import ErrorView from '@/components/ErrorView';

export type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function ErrorPage({ reset }: ErrorPageProps) {
  return <ErrorView reset={reset} />;
}
